module.exports = __webpack_public_path__ + "img/bmw3-2.cacc0acb.png";